import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import category from "../../../containers/modules/hr/category";

export default function CategoryEmployeeRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="category-employee"
      index
      element={
        <AccessControl
          name={"Category List"}
          auth={authUser}
          component={category}
        />
      }
    ></Route>
  );
}
